(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-grid-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-grid-gallery')) {
    class ImageGridGallery extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[ref="dialog"]');
        this.dialogImage = this.querySelector('[data-igg-image]');
        this.triggers = Array.from(this.querySelectorAll('[data-image-grid-trigger]'));
        this.currentIndex = 0;

        if (this.triggers.length <= 1) {
          this.classList.add('image-grid-gallery--single-image');
        }

        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeyDown);
        if (this.dialog) {
          this.dialog.addEventListener('click', this.handleDialogClick);
          this.dialog.addEventListener('close', this.handleDialogClose);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeyDown);
        if (this.dialog) {
          this.dialog.removeEventListener('click', this.handleDialogClick);
          this.dialog.removeEventListener('close', this.handleDialogClose);
        }
      }

      handleClick = (event) => {
        const trigger = event.target.closest('[data-image-grid-trigger]');
        if (trigger) {
          event.preventDefault();
          this.openAt(this.triggers.indexOf(trigger));
          return;
        }
        if (event.target.closest('[data-igg-close]')) {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.target.closest('[data-igg-prev]')) {
          event.preventDefault();
          this.step(-1);
          return;
        }
        if (event.target.closest('[data-igg-next]')) {
          event.preventDefault();
          this.step(1);
          return;
        }
      };

      handleDialogClick = (event) => {
        if (event.target === this.dialog) {
          this.close();
        }
      };

      handleDialogClose = () => {
        document.documentElement.style.removeProperty('overflow');
      };

      handleKeyDown = (event) => {
        if (!this.dialog || !this.dialog.open) return;
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.step(1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.step(-1);
        }
      };

      openAt(index) {
        if (!this.dialog || index < 0 || index >= this.triggers.length) return;
        this.currentIndex = index;
        this.renderCurrent();
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
        document.documentElement.style.overflow = 'hidden';
      }

      step(delta) {
        if (this.triggers.length === 0) return;
        const len = this.triggers.length;
        this.currentIndex = (this.currentIndex + delta + len) % len;
        this.renderCurrent();
      }

      renderCurrent() {
        const trigger = this.triggers[this.currentIndex];
        if (!trigger || !this.dialogImage) return;
        const src = trigger.getAttribute('data-full-src');
        const alt = trigger.getAttribute('data-alt') || '';
        if (this.dialogImage.getAttribute('src') !== src) {
          this.dialogImage.setAttribute('src', src);
        }
        this.dialogImage.setAttribute('alt', alt);
      }

      close() {
        if (!this.dialog) return;
        if (typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
        }
      }
    }

    customElements.define('image-grid-gallery', ImageGridGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
